import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import apiRequest from '../../lib/http'
import { normalizeError } from '../../utils/errorHelpers'

export const sendPaymentLink = createAsyncThunk(
  'paymentLink/send',
  async ({ userId, mode, amount, channels, selectedPaymentIds }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post('/payment-links', { userId, mode, amount, channels, selectedPaymentIds })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getSelectablePayments = createAsyncThunk(
  'paymentLink/getSelectable',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get('/payment-links/selectable', { params: { userId } })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const getPaymentLinkByToken = createAsyncThunk(
  'paymentLink/getByToken',
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.get(`/payment-links/${token}/anonymous`)
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

export const payByToken = createAsyncThunk(
  'paymentLink/pay',
  async ({ token, paymentToken }, { rejectWithValue }) => {
    try {
      const response = await apiRequest.post(`/payment-links/${token}/pay/anonymous`, { paymentToken })
      return response.data.data
    } catch (error) {
      return rejectWithValue(normalizeError(error))
    }
  }
)

const initialState = {
  sending: false,
  sendError: null,
  lastSent: null,
  link: null,
  loading: false,
  loadError: null,
  paying: false,
  payResult: null,
  payError: null,
  selectable: [],
  selectableLoading: false,
  selectableError: null,
}

const paymentLinkSlice = createSlice({
  name: 'paymentLink',
  initialState,
  reducers: {
    resetPaymentLink: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendPaymentLink.pending, (state) => {
        state.sending = true
        state.sendError = null
      })
      .addCase(sendPaymentLink.fulfilled, (state, action) => {
        state.sending = false
        state.lastSent = action.payload
      })
      .addCase(sendPaymentLink.rejected, (state, action) => {
        state.sending = false
        state.sendError = action.payload
      })
      .addCase(getPaymentLinkByToken.pending, (state) => {
        state.loading = true
        state.loadError = null
      })
      .addCase(getPaymentLinkByToken.fulfilled, (state, action) => {
        state.loading = false
        state.link = action.payload
      })
      .addCase(getPaymentLinkByToken.rejected, (state, action) => {
        state.loading = false
        state.loadError = action.payload
      })
      .addCase(payByToken.pending, (state) => {
        state.paying = true
        state.payError = null
      })
      .addCase(payByToken.fulfilled, (state, action) => {
        state.paying = false
        state.payResult = action.payload
      })
      .addCase(payByToken.rejected, (state, action) => {
        state.paying = false
        state.payError = action.payload
      })
      .addCase(getSelectablePayments.pending, (state) => {
        state.selectableLoading = true
        state.selectableError = null
      })
      .addCase(getSelectablePayments.fulfilled, (state, action) => {
        state.selectableLoading = false
        state.selectable = action.payload || []
      })
      .addCase(getSelectablePayments.rejected, (state, action) => {
        state.selectableLoading = false
        state.selectableError = action.payload
      })
  },
})

export const { resetPaymentLink } = paymentLinkSlice.actions
export default paymentLinkSlice.reducer
